import * as api from '../../api/api-are-busqueda-caso';
import { 
    GET_CONFIG_FORM32,
    GET_FECHAS,
    GET_COMBO_TIPO_GESTION,
    GET_COMBO_TIPO_ESTADO,
    GET_COMBO_SITUACION,
    GET_COMBO_TIPO_FECHA,
    GET_CONSULTA_CASOS,
    GET_EXCEL,
    CLEAN_CASOS,
    SET_QUERY_STATE
} from '../types';

export const configuracionFormAction32 = (query) => ({
    type: GET_CONFIG_FORM32,
    payload: api.getConfiguracionForm32(query)
});
export const obtenerFechas = (query) => ({
    type: GET_FECHAS,
    payload: api.getFechas(query)
});
export const obtenerComboTipoGestion = (query) => ({
    type: GET_COMBO_TIPO_GESTION,
    payload: api.getComboTipoGestion(query)
});
export const obtenerComboTipoEstado = (query) => ({
    type: GET_COMBO_TIPO_ESTADO,
    payload: api.getComboEstado(query)
});
export const obtenerComboSituacion = (query) => ({
    type: GET_COMBO_SITUACION,
    payload: api.getComboSituacion(query)
});
export const obtenerComboTipoFecha = (query) => ({
    type: GET_COMBO_TIPO_FECHA,
    payload: api.getComboTipoFecha(query)
});
export const obtenerConsultaCasos = (query) => ({
    type: GET_CONSULTA_CASOS,
    payload: api.getConsultaCasos(query)
});
export const obtenerExcel = (query) => ({
    type: GET_EXCEL,
    payload: api.getExcel(query)
});
export const limpiarCasos = () => ({
    type: CLEAN_CASOS,
  
});
export const setQueryState = (data) => ({
    type: SET_QUERY_STATE,
    payload:data
  
});


